/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./membership copy.vue?vue&type=template&id=0f0c276c&scoped=true"
import script from "./membership copy.vue?vue&type=script&lang=js"
export * from "./membership copy.vue?vue&type=script&lang=js"
import style0 from "./membership copy.vue?vue&type=style&index=0&id=0f0c276c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c276c",
  null
  
)

export default component.exports